import React from "react";
import styled from "@emotion/styled";
import { CSSProperties } from "@emotion/serialize";
import { Typography } from "@kaltura/ds-react-components";
import { systemWidth } from "@mediaspace/shared/styled";
import ReactHtmlParser from "@mediaspace/shared/ui/html-react-parser";

export interface TextOnlyProps {
    text?: string;
    color?: CSSProperties['color'];
    backgroundColor?: CSSProperties['color'];
}
const StyledTextOnlyWrapper = styled("div")(({ theme }) => ({
    "&": systemWidth({ theme }),
    display: "flex",
    justifyContent: "center",
}));

const StyledTextOnly = styled(Typography)<TextOnlyProps>(
    ({
        theme,
        backgroundColor = "transparent",
        color = "textPrimary",
    }) => ({
        color: color,
        backgroundColor: backgroundColor,
        display: "inline-block",
        fontSize: theme.typography.pxToRem(24),
        lineHeight: theme.typography.pxToRem(34),
        textAlign: "center",

        a: {
            fontSize: theme.typography.pxToRem(24),
        },
    })
);

/**
 *  TextOnly component shows text in the homepage
 */
export const TextOnly = (props: TextOnlyProps) => {
    const { text = "", color, backgroundColor } = props;

    return (
        <StyledTextOnlyWrapper className="kms-ds-homepage-component-textonly">
            <StyledTextOnly color={color} backgroundColor={backgroundColor}>
                {ReactHtmlParser(text)}
            </StyledTextOnly>
        </StyledTextOnlyWrapper>
    );
};

export default TextOnly;
